import React, { useState } from 'react';
import { TopHeader } from '@scope/scope-one-ui/core/TopHeader/TopHeader';
import { useDispatch, useSelector } from 'react-redux';
import { logoutAction } from 'store/login/loginAction';
import { useNavigate } from 'react-router-dom';
import { ChangePasswordModal } from 'modules/common/Modals';
import { useGetNotifications, useGeneralServices } from '../../../shared/hooks';
import { useNavigator } from './hooks/useNavigator';
import { useMenuBookmarks } from '../../../shared/hooks';
import { useCre } from './hooks/useCre';
import { useFunds } from './hooks/useFunds';

const Navbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data } = useSelector(({ auth }) => auth);

  const [changePasswordModalOpen, setChangePasswordOpen] = useState(false);

  const toggleChangePasswordModal = () => {
    setChangePasswordOpen(!changePasswordModalOpen);
  };

  const redirect = (path) => {
    navigate(path);
  };

  const userMenu = {
    user: {
      firstName: `${data.firstName}`,
      lastName: `${data.name}`,
      jobTitle: `${data.user && data.user.jobTitle}`,
    },
    onViewProfile: () => redirect('/profile'),
    onChangePassword: () => toggleChangePasswordModal(),
    onNewsCenter: () => redirect('/news-centre'),
    onLogout: () => dispatch(logoutAction),
  };
  const notifications = useGetNotifications();
  const generalServices = useGeneralServices();
  const bookmarks = useMenuBookmarks();
  const navigatorOptions = useNavigator();
  const creOptions = useCre();
  const fundsOptions = useFunds();

  const accessOptions = {
    ...navigatorOptions,
    ...creOptions,
    ...fundsOptions,
  };

  return (
    <>
      <TopHeader
        title="PageOne"
        activeUrl="/page-one"
        hasSettings={false}
        userMenu={userMenu}
        notifications={notifications}
        generalServices={generalServices}
        bookmarks={bookmarks}
        accessOptions={accessOptions}
      />
      <ChangePasswordModal open={changePasswordModalOpen} onClose={toggleChangePasswordModal} />
    </>
  );
};

export default Navbar;
